<template>
  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl"
    :class="isRTL ? 'me-3 rotate-caret' : 'ms-3'"
    id="sidenav-main"
  >
    <div class="sidenav-header" style="height: auto !important; min-height: 100px;">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <a class="m-0 navbar-brand d-flex align-items-center justify-content-center" href="/" style="padding: 20px 10px;">
        <!-- 
          Changes made:
          1. Height set to 60px (much larger)
          2. max-height: none (prevents the template from shrinking it)
          3. filter: invert(1) (makes the black logo white)
        -->
        <img 
          :src="logo" 
          class="navbar-brand-img" 
          style="height: 60px !important; max-height: none !important; width: auto !important; filter: brightness(0) invert(1);" 
          alt="main_logo" 
        />
        <span class="ms-2 font-weight-bold text-white" style="font-size: 1.4rem; letter-spacing: 1px;">Aerion</span>
      </a>
    </div>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list :cardBg="customClass" />
  </aside>
</template>

<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logo.png"; 
import { mapState } from "vuex";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo,
    };
  },
  props: {
    customClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(["isRTL"]),
  },
};
</script>

<style scoped>
/* Force the header to be tall enough for the bigger logo */
.sidenav-header {
  height: 120px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Ensure the text doesn't wrap weirdly */
.navbar-brand span {
  white-space: nowrap;
}
</style>